import React, { useState } from "react";
import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Entertainers from "@/components/site/Entertainers";
import Offerings from "@/components/site/Offerings";
import Gallery from "@/components/site/Gallery";
import Staff from "@/components/site/Staff";
import OpeningHours from "@/components/site/OpeningHours";
import Footer from "@/components/site/Footer";
import BookingDialog from "@/components/site/BookingDialog";

export default function LandingPage() {
  const [bookOpen, setBookOpen] = useState(false);
  const openBook = () => setBookOpen(true);

  return (
    <main data-testid="landing-page" className="relative bg-neutral-950 text-white">
      <Navigation onBook={openBook} />
      <Hero onBook={openBook} />
      <About />
      <Offerings />
      <Entertainers />
      <Gallery />
      <Staff />
      <OpeningHours onBook={openBook} />
      <Footer />
      <BookingDialog open={bookOpen} onOpenChange={setBookOpen} />
    </main>
  );
}
